import React, {Component} from 'react';
import memont from 'moment';
import {Button, Modal} from 'react-bootstrap';
import {Link} from 'react-router';
import { 
  fetchConstructionDataAPI, 
  trypUpdateConstruction 
} from 'actions/ConstructionActions';
import {getURL} from '../../routes';

class ConstructionEditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cid: 0,
      name: "",
      year: memont().year(),
      assignTo: "",
      status: "",
      nameErrorMsg: "",
    }
  }

  componentDidMount() {
    if (this.props.workOn > 0) {
      fetchConstructionDataAPI(this.props.workOn)
        .then(function(response) {
          let data = response.data;
          this.setState(data); 
        }.bind(this));    
    }
  }
  
  nameValidtor = (name) => {
    let len = name.length;
    if (len === 0) return "工程名稱不能為空"
    if (len > 45) return "工程名稱長度必須小於 45"
    return "";
  }

  handldeNameChange = (e) => {
    let name = e.target.value;
    this.setState({
      name: name, 
      nameErrorMsg: this.nameValidtor(name)
    })
  }

  handleYear = (e) => {
    this.setState({year: parseInt(e.target.value, 10) || memont().year() + 1})
  }

  handleAssginTo = (e) => {
    this.setState({assignTo: parseInt(e.target.value, 10)})
  }

  handleStatus = (e) => {
    this.setState({status: parseInt(e.target.value, 10)})
  }

  handleSave = () => {
    let {cid, name, year, assignTo, status} = this.state;
    this.props.dispatch(trypUpdateConstruction(cid, name, year, assignTo, status, this.props.handleDisMissModal))
  }

  render() {
    let {handleDisMissModal, companyList, workOn} = this.props;
    let {name, year, nameErrorMsg, assignTo, status} = this.state;

    return (
      <Modal.Dialog>
        <Modal.Header>
          <Modal.Title>
            工程編號 - {workOn}
            <span 
              className="btn btn-danger btn-xs dismiss-btn glyphicon glyphicon-remove pull-right"
              onClick={handleDisMissModal}>
            </span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form className="form-horizontal">
            <div className="form-group">
              <label className="col-sm-3 control-label">工程年份</label>
              <div className="col-sm-9">
                <select 
                  className="form-control" 
                  value={year} 
                  onChange={this.handleYear}>
                  {Array.from(Array(5), (x, i) => year - (i + 1)).reverse().map(y => (
                      <option value={y} key={y}>{y}</option>
                    ))
                  }
                  <option value={year} key={year}>{year}</option>
                  {Array.from(Array(5), (x, i) => year + i + 1).map(y => (
                      <option value={y} key={y}>{y}</option>
                    ))
                  }
                </select>         
              </div>
            </div>
            <div className="form-group">
              <label className="col-sm-3 control-label">工程名稱</label>
              <div className="col-sm-9">
                <input
                  type="text"
                  value={name}
                  onChange={this.handldeNameChange}
                  className="form-control"
                />
                {nameErrorMsg.length > 0 &&
                  <span className="error-msg">
                    - {nameErrorMsg}
                  </span>}                
              </div>
            </div>

            <div className="form-group">
              <label className="col-sm-3 control-label">執行公司</label>
              <div className="col-sm-9">
                <select 
                  className="form-control" 
                  value={assignTo} 
                  onChange={this.handleAssginTo}>
                  {companyList.map((company) => (
                    <option value={company.get('id')} key={company.get('id')}>
                      {company.get('name')}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-group">
              <label className="col-sm-3 control-label">工程狀態</label>
              <div className="col-sm-9">
                <select 
                  className="form-control" 
                  value={status} 
                  onChange={this.handleStatus}>
                  <option value={0}>進行中</option>
                  <option value={1}>已完成</option>
                </select>
              </div>
            </div>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Link 
            className="btn btn-default pull-left"
            to={getURL("/ws-admin/report/cost/") + workOn} 
            target="_blank" >
            匯出成本報表
          </Link>
          <Button 
            bsStyle="primary"
            onClick={this.handleSave}
          >
            存儲
          </Button>
          <Button onClick={handleDisMissModal}>關閉</Button>
        </Modal.Footer>
      </Modal.Dialog>
    )
  }
}

export default ConstructionEditModal;


// WEBPACK FOOTER //
// ./src/components/Construction/ConstructionEditModal.js